import { render } from "./BalanceView.vue?vue&type=template&id=79b29b30&scoped=true"
import script from "./BalanceView.vue?vue&type=script&lang=js"
export * from "./BalanceView.vue?vue&type=script&lang=js"

import "./BalanceView.vue?vue&type=style&index=0&id=79b29b30&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b29b30"]])

export default __exports__